module.exports = new __parcel__URL__("C3S1.076aa2a6.png").toString();